var map = {
	"./assets/fonts/fredoka-one-v13-latin/fredoka-one-v13-latin-regular.svg": 95300,
	"./assets/fonts/mulish-v12-latin/mulish-v12-latin-regular.svg": 65429,
	"./assets/fonts/sunn-main/SUIT-Bold.svg": 26862,
	"./assets/fonts/sunn-main/SUIT-ExtraBold.svg": 11035,
	"./assets/fonts/sunn-main/SUIT-ExtraLight.svg": 2666,
	"./assets/fonts/sunn-main/SUIT-Heavy.svg": 31195,
	"./assets/fonts/sunn-main/SUIT-Light.svg": 91270,
	"./assets/fonts/sunn-main/SUIT-Medium.svg": 79626,
	"./assets/fonts/sunn-main/SUIT-Regular.svg": 88674,
	"./assets/fonts/sunn-main/SUIT-SemiBold.svg": 23904,
	"./assets/fonts/sunn-main/SUIT-Thin.svg": 82017,
	"./assets/img/ace_logo.svg": 57998,
	"./assets/img/agreeClose.svg": 60814,
	"./assets/img/agreeart.svg": 93602,
	"./assets/img/allUserso.svg": 46493,
	"./assets/img/all_off.svg": 62048,
	"./assets/img/all_on.svg": 29484,
	"./assets/img/answerbg.svg": 60397,
	"./assets/img/arrowL.svg": 24465,
	"./assets/img/arrowR.svg": 67387,
	"./assets/img/asiagaming.svg": 13535,
	"./assets/img/asiagaming_on.svg": 53912,
	"./assets/img/ask_off.svg": 23328,
	"./assets/img/ask_on.svg": 66815,
	"./assets/img/askbg.svg": 86487,
	"./assets/img/aspectgaming.svg": 71762,
	"./assets/img/aspectgaming_on.svg": 63265,
	"./assets/img/banana_logobk.svg": 81226,
	"./assets/img/banana_logowh.svg": 26477,
	"./assets/img/betting_off.svg": 18899,
	"./assets/img/betting_on.svg": 39100,
	"./assets/img/bettinglist_off.svg": 51497,
	"./assets/img/bettinglist_on.svg": 85345,
	"./assets/img/biggaming.svg": 20571,
	"./assets/img/biggaming_on.svg": 99510,
	"./assets/img/bigtimegaming.svg": 7737,
	"./assets/img/bigtimegaming_on.svg": 80526,
	"./assets/img/blaze_logo.svg": 32041,
	"./assets/img/blaze_logob.svg": 46119,
	"./assets/img/blueprint.svg": 29053,
	"./assets/img/blueprint_on.svg": 52809,
	"./assets/img/booongo.svg": 44095,
	"./assets/img/booongo_on.svg": 94180,
	"./assets/img/bpnut_logo.svg": 248,
	"./assets/img/cash-title-arrow-icon.svg": 52631,
	"./assets/img/casino_bg.svg": 41720,
	"./assets/img/charexchange_off.svg": 22041,
	"./assets/img/charexchange_on.svg": 67341,
	"./assets/img/charges.svg": 56859,
	"./assets/img/charges_active.svg": 57476,
	"./assets/img/charges_on.svg": 92619,
	"./assets/img/checkImg.svg": 91701,
	"./assets/img/close_message.svg": 50796,
	"./assets/img/cn.svg": 54059,
	"./assets/img/contact_off.svg": 58560,
	"./assets/img/contact_on.svg": 38590,
	"./assets/img/cq9.svg": 5685,
	"./assets/img/cq9_on.svg": 26658,
	"./assets/img/cscenterBox.svg": 47830,
	"./assets/img/currentPointo.svg": 9231,
	"./assets/img/distributor_off.svg": 68796,
	"./assets/img/distributor_on.svg": 2410,
	"./assets/img/dowinn.svg": 85399,
	"./assets/img/dowinn_on.svg": 88322,
	"./assets/img/dragonsoft.svg": 32520,
	"./assets/img/dragonsoft_on.svg": 65755,
	"./assets/img/dreamgaming.svg": 23153,
	"./assets/img/dreamgaming_on.svg": 57701,
	"./assets/img/e-sports_off.svg": 33507,
	"./assets/img/e-sports_on.svg": 60662,
	"./assets/img/elk.svg": 72893,
	"./assets/img/elk_on.svg": 24667,
	"./assets/img/elysium.svg": 99087,
	"./assets/img/elysium_on.svg": 36104,
	"./assets/img/en.svg": 61999,
	"./assets/img/etc_off.svg": 76954,
	"./assets/img/etc_on.svg": 18313,
	"./assets/img/evolution.svg": 86369,
	"./assets/img/evolution_on.svg": 47981,
	"./assets/img/exchange_off.svg": 305,
	"./assets/img/exchange_on.svg": 69384,
	"./assets/img/exchanges.svg": 92905,
	"./assets/img/exchanges_active.svg": 74972,
	"./assets/img/exchanges_on.svg": 39297,
	"./assets/img/ezugi.svg": 98595,
	"./assets/img/ezugi_on.svg": 3276,
	"./assets/img/flag.svg": 86344,
	"./assets/img/footer_CQ9.svg": 65688,
	"./assets/img/footer_asiagaming.svg": 31461,
	"./assets/img/footer_dreamgaming.svg": 97740,
	"./assets/img/footer_evolution.svg": 60013,
	"./assets/img/footer_microgaming.svg": 24017,
	"./assets/img/footer_netent.svg": 6017,
	"./assets/img/footer_playson.svg": 20263,
	"./assets/img/footer_pragmaticplay.svg": 98157,
	"./assets/img/footer_redtiger.svg": 15173,
	"./assets/img/footer_uig.svg": 21805,
	"./assets/img/footer_worldmatch.svg": 30477,
	"./assets/img/game_bg.svg": 24269,
	"./assets/img/game_main_pc_1.svg": 60879,
	"./assets/img/game_main_pc_12.svg": 42796,
	"./assets/img/game_main_pc_12_off.svg": 18465,
	"./assets/img/game_main_pc_13.svg": 19109,
	"./assets/img/game_main_pc_13_off.svg": 96276,
	"./assets/img/game_main_pc_16.svg": 69152,
	"./assets/img/game_main_pc_16_off.svg": 35142,
	"./assets/img/game_main_pc_17.svg": 33839,
	"./assets/img/game_main_pc_17_off.svg": 57177,
	"./assets/img/game_main_pc_1_off.svg": 1389,
	"./assets/img/game_main_pc_2.svg": 5543,
	"./assets/img/game_main_pc_200.svg": 60305,
	"./assets/img/game_main_pc_200_off.svg": 43745,
	"./assets/img/game_main_pc_201.svg": 97952,
	"./assets/img/game_main_pc_201_off.svg": 67007,
	"./assets/img/game_main_pc_204.svg": 5411,
	"./assets/img/game_main_pc_204_off.svg": 23466,
	"./assets/img/game_main_pc_205.svg": 72045,
	"./assets/img/game_main_pc_205_off.svg": 10617,
	"./assets/img/game_main_pc_207.svg": 66610,
	"./assets/img/game_main_pc_207_off.svg": 91633,
	"./assets/img/game_main_pc_208.svg": 1032,
	"./assets/img/game_main_pc_208_off.svg": 89294,
	"./assets/img/game_main_pc_209.svg": 34701,
	"./assets/img/game_main_pc_209_off.svg": 86862,
	"./assets/img/game_main_pc_212.svg": 35305,
	"./assets/img/game_main_pc_212_off.svg": 8472,
	"./assets/img/game_main_pc_213.svg": 88343,
	"./assets/img/game_main_pc_213_off.svg": 74139,
	"./assets/img/game_main_pc_214.svg": 29784,
	"./assets/img/game_main_pc_214_off.svg": 59094,
	"./assets/img/game_main_pc_215.svg": 67354,
	"./assets/img/game_main_pc_215_off.svg": 56100,
	"./assets/img/game_main_pc_216.svg": 84985,
	"./assets/img/game_main_pc_216_off.svg": 13378,
	"./assets/img/game_main_pc_217.svg": 24617,
	"./assets/img/game_main_pc_217_off.svg": 76587,
	"./assets/img/game_main_pc_218.svg": 1212,
	"./assets/img/game_main_pc_218_off.svg": 30479,
	"./assets/img/game_main_pc_219.svg": 15575,
	"./assets/img/game_main_pc_219_off.svg": 84256,
	"./assets/img/game_main_pc_220.svg": 18914,
	"./assets/img/game_main_pc_220_off.svg": 20683,
	"./assets/img/game_main_pc_221.svg": 54156,
	"./assets/img/game_main_pc_221_off.svg": 55238,
	"./assets/img/game_main_pc_222.svg": 36756,
	"./assets/img/game_main_pc_222_off.svg": 69243,
	"./assets/img/game_main_pc_223.svg": 10129,
	"./assets/img/game_main_pc_223_off.svg": 74966,
	"./assets/img/game_main_pc_224.svg": 94583,
	"./assets/img/game_main_pc_224_off.svg": 33122,
	"./assets/img/game_main_pc_225.svg": 80759,
	"./assets/img/game_main_pc_225_off.svg": 89553,
	"./assets/img/game_main_pc_226.svg": 19264,
	"./assets/img/game_main_pc_226_off.svg": 74534,
	"./assets/img/game_main_pc_227.svg": 78266,
	"./assets/img/game_main_pc_227_off.svg": 46367,
	"./assets/img/game_main_pc_228.svg": 34255,
	"./assets/img/game_main_pc_228_off.svg": 83669,
	"./assets/img/game_main_pc_2_off.svg": 87020,
	"./assets/img/game_main_pc_301.svg": 83967,
	"./assets/img/game_main_pc_301_off.svg": 8626,
	"./assets/img/game_main_pc_6.svg": 15444,
	"./assets/img/game_main_pc_6_off.svg": 43060,
	"./assets/img/game_main_pc_bomb.svg": 28497,
	"./assets/img/game_main_pc_bomb_off.svg": 12962,
	"./assets/img/game_main_pc_sp.svg": 8445,
	"./assets/img/game_main_pc_sp_off.svg": 27158,
	"./assets/img/gameart.svg": 78115,
	"./assets/img/gameart_on.svg": 71938,
	"./assets/img/gdclose.svg": 23514,
	"./assets/img/givemoney.svg": 51481,
	"./assets/img/givemoney_active.svg": 95686,
	"./assets/img/gmw.svg": 76579,
	"./assets/img/gmw_on.svg": 48920,
	"./assets/img/habanero.svg": 62621,
	"./assets/img/habanero_on.svg": 46078,
	"./assets/img/hcoin.svg": 23059,
	"./assets/img/hmsg.svg": 97407,
	"./assets/img/hpoint.svg": 47097,
	"./assets/img/icon-calendar.svg": 10258,
	"./assets/img/icon-card-white.svg": 32728,
	"./assets/img/icon-check-blue.svg": 41894,
	"./assets/img/icon-message-new.svg": 29721,
	"./assets/img/icon-message-read.svg": 36791,
	"./assets/img/icon-phone-white.svg": 65624,
	"./assets/img/icon-phonebank-white.svg": 77477,
	"./assets/img/icon-qna-solved.svg": 72243,
	"./assets/img/icon-qna-wait.svg": 70434,
	"./assets/img/icon-shield-black.svg": 72128,
	"./assets/img/icon-shield-blue.svg": 60072,
	"./assets/img/icon-write.svg": 14634,
	"./assets/img/icon/user-tie.svg": 55644,
	"./assets/img/icon_airplane.svg": 97579,
	"./assets/img/icon_arrow.svg": 33094,
	"./assets/img/icon_barrow.svg": 54387,
	"./assets/img/icon_bet.svg": 37893,
	"./assets/img/icon_bettinglist.svg": 76382,
	"./assets/img/icon_bkArrow.svg": 27566,
	"./assets/img/icon_cancel.svg": 10266,
	"./assets/img/icon_cash.svg": 64881,
	"./assets/img/icon_casino.svg": 897,
	"./assets/img/icon_check.svg": 91636,
	"./assets/img/icon_check2.svg": 96658,
	"./assets/img/icon_cherry.svg": 92984,
	"./assets/img/icon_close.svg": 70268,
	"./assets/img/icon_coin.svg": 80658,
	"./assets/img/icon_copy.svg": 56047,
	"./assets/img/icon_cs.svg": 39299,
	"./assets/img/icon_cscenter.svg": 27240,
	"./assets/img/icon_csnotice.svg": 21931,
	"./assets/img/icon_date.svg": 55412,
	"./assets/img/icon_deposit.svg": 46219,
	"./assets/img/icon_dice.svg": 44713,
	"./assets/img/icon_distributor.svg": 31608,
	"./assets/img/icon_exchange.svg": 24506,
	"./assets/img/icon_faq.svg": 8768,
	"./assets/img/icon_freeboard.svg": 71533,
	"./assets/img/icon_game.svg": 66928,
	"./assets/img/icon_gameM.svg": 82814,
	"./assets/img/icon_gameguide.svg": 59032,
	"./assets/img/icon_gcash.svg": 63017,
	"./assets/img/icon_give.svg": 67988,
	"./assets/img/icon_gmoney.svg": 7287,
	"./assets/img/icon_go.svg": 93723,
	"./assets/img/icon_gpoint.svg": 56155,
	"./assets/img/icon_home.svg": 68600,
	"./assets/img/icon_info.svg": 56714,
	"./assets/img/icon_livecasino.svg": 39215,
	"./assets/img/icon_logout.svg": 40848,
	"./assets/img/icon_mega.svg": 19477,
	"./assets/img/icon_mini.svg": 68326,
	"./assets/img/icon_more.svg": 89217,
	"./assets/img/icon_mores.svg": 25908,
	"./assets/img/icon_msg.svg": 71997,
	"./assets/img/icon_msgbg.svg": 98501,
	"./assets/img/icon_my.svg": 44985,
	"./assets/img/icon_myicon.svg": 47104,
	"./assets/img/icon_notice.svg": 66499,
	"./assets/img/icon_out.svg": 77647,
	"./assets/img/icon_play.svg": 47487,
	"./assets/img/icon_plus.svg": 43268,
	"./assets/img/icon_point.svg": 48225,
	"./assets/img/icon_question.svg": 64592,
	"./assets/img/icon_qusetion.svg": 71953,
	"./assets/img/icon_ranking.svg": 37716,
	"./assets/img/icon_re.svg": 65819,
	"./assets/img/icon_reset.svg": 11201,
	"./assets/img/icon_search.svg": 8424,
	"./assets/img/icon_shortcut.svg": 79218,
	"./assets/img/icon_slot.svg": 95222,
	"./assets/img/icon_slotClose.svg": 85648,
	"./assets/img/icon_slotgame.svg": 89733,
	"./assets/img/icon_snotice.svg": 68865,
	"./assets/img/icon_spade.svg": 5490,
	"./assets/img/icon_spoint.svg": 36640,
	"./assets/img/icon_tele.svg": 18245,
	"./assets/img/icon_tmore.svg": 70061,
	"./assets/img/icon_trash.svg": 35147,
	"./assets/img/icon_user.svg": 83319,
	"./assets/img/icon_withdrawal.svg": 80601,
	"./assets/img/icon_zalo.svg": 19260,
	"./assets/img/img_card1.svg": 81658,
	"./assets/img/img_card2.svg": 66124,
	"./assets/img/img_card3.svg": 84330,
	"./assets/img/img_coin.svg": 87635,
	"./assets/img/img_point.svg": 67621,
	"./assets/img/jackpotImg.svg": 14947,
	"./assets/img/jackpotTime.svg": 51909,
	"./assets/img/jackpotTxt.svg": 63372,
	"./assets/img/jackpot_bg.svg": 40235,
	"./assets/img/join_bg.svg": 70714,
	"./assets/img/jp.svg": 79508,
	"./assets/img/kakao.svg": 62325,
	"./assets/img/korea.svg": 62149,
	"./assets/img/kr.svg": 91295,
	"./assets/img/livecasino_dreamgaming.svg": 51196,
	"./assets/img/livecasino_evolution.svg": 82254,
	"./assets/img/livecasino_off.svg": 90763,
	"./assets/img/livecasino_on.svg": 19131,
	"./assets/img/login_bg.svg": 6919,
	"./assets/img/login_logo.svg": 40674,
	"./assets/img/loginbtn_bg.svg": 49868,
	"./assets/img/logo_1.svg": 51404,
	"./assets/img/logo_10.svg": 155,
	"./assets/img/logo_15.svg": 20221,
	"./assets/img/logo_214.svg": 6936,
	"./assets/img/logo_228.svg": 60419,
	"./assets/img/logo_5.svg": 12655,
	"./assets/img/logouticon.svg": 42377,
	"./assets/img/lucky_bg.svg": 63054,
	"./assets/img/mBg1_off.svg": 20756,
	"./assets/img/mBg1_on.svg": 84156,
	"./assets/img/mBg2_off.svg": 42332,
	"./assets/img/mBg2_on.svg": 6661,
	"./assets/img/mBg3_off.svg": 61550,
	"./assets/img/mBg3_on.svg": 40374,
	"./assets/img/mBg4_off.svg": 37739,
	"./assets/img/mBg4_on.svg": 27839,
	"./assets/img/mBg5_off.svg": 68166,
	"./assets/img/mBg5_on.svg": 29700,
	"./assets/img/main_bg.svg": 13821,
	"./assets/img/maverick.svg": 96785,
	"./assets/img/maverick_on.svg": 26127,
	"./assets/img/message.svg": 54179,
	"./assets/img/message_off.svg": 21064,
	"./assets/img/message_on.svg": 51103,
	"./assets/img/messages_off.svg": 90150,
	"./assets/img/messages_on.svg": 4847,
	"./assets/img/micon1.svg": 65242,
	"./assets/img/micon2.svg": 297,
	"./assets/img/micon3.svg": 7437,
	"./assets/img/micon4.svg": 22806,
	"./assets/img/microgaming.svg": 13656,
	"./assets/img/microgaming_on.svg": 85027,
	"./assets/img/minigame_off.svg": 54942,
	"./assets/img/minigame_on.svg": 7946,
	"./assets/img/moca_logo.svg": 70500,
	"./assets/img/moneygive_off.svg": 56711,
	"./assets/img/moneygive_on.svg": 56963,
	"./assets/img/msg_bg.svg": 5153,
	"./assets/img/myfixBg.svg": 82919,
	"./assets/img/namecasino.svg": 43382,
	"./assets/img/nameslot.svg": 69838,
	"./assets/img/netent.svg": 17714,
	"./assets/img/netent_on.svg": 81007,
	"./assets/img/notice-icon.svg": 74516,
	"./assets/img/notice_off.svg": 86901,
	"./assets/img/notice_on.svg": 75319,
	"./assets/img/open_message.svg": 44784,
	"./assets/img/orange_logo.svg": 70611,
	"./assets/img/orientalgame.svg": 31510,
	"./assets/img/orientalgame_on.svg": 68740,
	"./assets/img/pageL.svg": 30088,
	"./assets/img/pageR.svg": 36985,
	"./assets/img/pang_logo.svg": 90383,
	"./assets/img/pgsoft.svg": 8833,
	"./assets/img/pgsoft_on.svg": 5482,
	"./assets/img/playngo.svg": 58956,
	"./assets/img/playngo_on.svg": 17199,
	"./assets/img/playson.svg": 25910,
	"./assets/img/playson_on.svg": 12475,
	"./assets/img/point_off.svg": 43193,
	"./assets/img/point_on.svg": 60437,
	"./assets/img/pointo.svg": 88891,
	"./assets/img/pragmaticplay.svg": 63157,
	"./assets/img/pragmaticplay_on.svg": 56965,
	"./assets/img/progresso.svg": 88941,
	"./assets/img/qna_bet.svg": 19460,
	"./assets/img/qna_casino.svg": 54546,
	"./assets/img/qna_etc.svg": 46461,
	"./assets/img/qna_money.svg": 69093,
	"./assets/img/qna_slot.svg": 29605,
	"./assets/img/qna_total.svg": 92941,
	"./assets/img/quickspin.svg": 86741,
	"./assets/img/quickspin_on.svg": 78529,
	"./assets/img/rankingbg.svg": 46901,
	"./assets/img/redrake.svg": 55035,
	"./assets/img/redrake_on.svg": 13011,
	"./assets/img/redtiger.svg": 34721,
	"./assets/img/redtiger_on.svg": 66470,
	"./assets/img/relaxgaming.svg": 44762,
	"./assets/img/relaxgaming_on.svg": 90522,
	"./assets/img/search.svg": 43655,
	"./assets/img/service1.svg": 33991,
	"./assets/img/service2.svg": 98094,
	"./assets/img/service3.svg": 45647,
	"./assets/img/setting_completeo.svg": 54920,
	"./assets/img/setting_incompleteo.svg": 50275,
	"./assets/img/slideleft.svg": 18831,
	"./assets/img/slideright.svg": 72087,
	"./assets/img/slotBg_off.svg": 33647,
	"./assets/img/slotBg_on.svg": 18254,
	"./assets/img/slot_ELK_off.svg": 79200,
	"./assets/img/slot_ELK_on.svg": 63862,
	"./assets/img/slot_asia_off.svg": 38945,
	"./assets/img/slot_asia_on.svg": 28969,
	"./assets/img/slot_blue_off.svg": 64457,
	"./assets/img/slot_blue_on.svg": 88721,
	"./assets/img/slot_boongo_off.svg": 91759,
	"./assets/img/slot_boongo_on.svg": 54394,
	"./assets/img/slot_cq9_off.svg": 1455,
	"./assets/img/slot_cq9_on.svg": 60838,
	"./assets/img/slot_dreak_off.svg": 81210,
	"./assets/img/slot_dreak_on.svg": 61825,
	"./assets/img/slot_ele_off.svg": 36146,
	"./assets/img/slot_ele_on.svg": 17249,
	"./assets/img/slot_evored_off.svg": 70883,
	"./assets/img/slot_evored_on.svg": 58879,
	"./assets/img/slot_haba_off.svg": 37079,
	"./assets/img/slot_haba_on.svg": 7740,
	"./assets/img/slot_head_off.svg": 35615,
	"./assets/img/slot_head_on.svg": 36363,
	"./assets/img/slot_icon.svg": 77694,
	"./assets/img/slot_mebrk_off.svg": 8161,
	"./assets/img/slot_mebrk_on.svg": 10739,
	"./assets/img/slot_mic_off.svg": 55463,
	"./assets/img/slot_mic_on.svg": 81573,
	"./assets/img/slot_net_off.svg": 50115,
	"./assets/img/slot_net_on.svg": 18290,
	"./assets/img/slot_off.svg": 27043,
	"./assets/img/slot_on.svg": 62376,
	"./assets/img/slot_playngo_off.svg": 26488,
	"./assets/img/slot_playngo_on.svg": 85409,
	"./assets/img/slot_playsen_off.svg": 8852,
	"./assets/img/slot_playsen_on.svg": 4458,
	"./assets/img/slot_prag_off.svg": 81422,
	"./assets/img/slot_prag_on.svg": 37618,
	"./assets/img/slot_qick_off.svg": 71,
	"./assets/img/slot_qick_on.svg": 7478,
	"./assets/img/slot_relex_off.svg": 11596,
	"./assets/img/slot_relex_on.svg": 5599,
	"./assets/img/slot_soft_off.svg": 48281,
	"./assets/img/slot_soft_on.svg": 59273,
	"./assets/img/slotbox_bg.svg": 20624,
	"./assets/img/slotrank_icon.svg": 31188,
	"./assets/img/snavhomeicon.svg": 41304,
	"./assets/img/spearhead.svg": 75626,
	"./assets/img/spearhead_on.svg": 38899,
	"./assets/img/sports_off.svg": 84675,
	"./assets/img/sports_on.svg": 86702,
	"./assets/img/strbg.svg": 1339,
	"./assets/img/sub_bg.svg": 61693,
	"./assets/img/tableBg.svg": 96875,
	"./assets/img/table_bg.svg": 5997,
	"./assets/img/tele.svg": 57773,
	"./assets/img/th.svg": 64549,
	"./assets/img/thisweek_icon.svg": 87220,
	"./assets/img/titan_logo.svg": 74083,
	"./assets/img/today_icon.svg": 4994,
	"./assets/img/treasure_logo.svg": 4995,
	"./assets/img/us.svg": 40000,
	"./assets/img/usePointo.svg": 36570,
	"./assets/img/userset_off.svg": 51501,
	"./assets/img/userset_on.svg": 45680,
	"./assets/img/vivogaming.svg": 42505,
	"./assets/img/vivogaming_on.svg": 99845,
	"./assets/img/vn.svg": 3768,
	"./assets/img/warningClose.svg": 10587,
	"./assets/img/warningart.svg": 74447,
	"./assets/img/web-profile-icon.svg": 48370,
	"./assets/img/whpnut_logo.svg": 1421,
	"./assets/img/wm-casino.svg": 22939,
	"./assets/img/wm-casino_on.svg": 65215,
	"./assets/img/ywclose.svg": 87920,
	"./assets/img/zalo.svg": 38708,
	"./assets_mobile/img/allBg1.svg": 44863,
	"./assets_mobile/img/allBg2.svg": 35327,
	"./assets_mobile/img/allBg3.svg": 55716,
	"./assets_mobile/img/allBg4.svg": 42647,
	"./assets_mobile/img/allBg5.svg": 8532,
	"./assets_mobile/img/allBg6.svg": 37148,
	"./assets_mobile/img/allUserso.svg": 87253,
	"./assets_mobile/img/all_bg1.svg": 58978,
	"./assets_mobile/img/all_bg2.svg": 78854,
	"./assets_mobile/img/all_bg3.svg": 82908,
	"./assets_mobile/img/all_bg4.svg": 78009,
	"./assets_mobile/img/all_bg5.svg": 30744,
	"./assets_mobile/img/all_bg6.svg": 84936,
	"./assets_mobile/img/all_off.svg": 31343,
	"./assets_mobile/img/all_on.svg": 89932,
	"./assets_mobile/img/asiaGaming_m.svg": 56693,
	"./assets_mobile/img/bananab_logo.svg": 2074,
	"./assets_mobile/img/bananam_logo.svg": 41417,
	"./assets_mobile/img/bannerChange.svg": 30160,
	"./assets_mobile/img/bannerCharge.svg": 89224,
	"./assets_mobile/img/bbtn_bg.svg": 33250,
	"./assets_mobile/img/blaze_logo.svg": 81156,
	"./assets_mobile/img/blueprint_m.svg": 49510,
	"./assets_mobile/img/bnanan_logo.svg": 61977,
	"./assets_mobile/img/booongo_m.svg": 50733,
	"./assets_mobile/img/bpnut_logo.svg": 14653,
	"./assets_mobile/img/btn_bg1.svg": 29189,
	"./assets_mobile/img/btn_bg2.svg": 32382,
	"./assets_mobile/img/cash_bg.svg": 81026,
	"./assets_mobile/img/close_message.svg": 27208,
	"./assets_mobile/img/cq9_m.svg": 32456,
	"./assets_mobile/img/currentPointo.svg": 54853,
	"./assets_mobile/img/dowinn.svg": 9960,
	"./assets_mobile/img/dragonsoft_m.svg": 33564,
	"./assets_mobile/img/dreamgaming.svg": 60008,
	"./assets_mobile/img/elk_m.svg": 54464,
	"./assets_mobile/img/elysium_m.svg": 7636,
	"./assets_mobile/img/evolution.svg": 51084,
	"./assets_mobile/img/flag.svg": 10939,
	"./assets_mobile/img/gameStart.svg": 66256,
	"./assets_mobile/img/game_main_mobile_1.svg": 48391,
	"./assets_mobile/img/game_main_mobile_13.svg": 69470,
	"./assets_mobile/img/game_main_mobile_15.svg": 66778,
	"./assets_mobile/img/game_main_mobile_200.svg": 54552,
	"./assets_mobile/img/game_main_mobile_201.svg": 19869,
	"./assets_mobile/img/game_main_mobile_204.svg": 80522,
	"./assets_mobile/img/game_main_mobile_205.svg": 74492,
	"./assets_mobile/img/game_main_mobile_207.svg": 40796,
	"./assets_mobile/img/game_main_mobile_208.svg": 81397,
	"./assets_mobile/img/game_main_mobile_209.svg": 25700,
	"./assets_mobile/img/game_main_mobile_212.svg": 92904,
	"./assets_mobile/img/game_main_mobile_213.svg": 2435,
	"./assets_mobile/img/game_main_mobile_214.svg": 6087,
	"./assets_mobile/img/game_main_mobile_215.svg": 92771,
	"./assets_mobile/img/game_main_mobile_216.svg": 37581,
	"./assets_mobile/img/game_main_mobile_217.svg": 34870,
	"./assets_mobile/img/game_main_mobile_218.svg": 29356,
	"./assets_mobile/img/game_main_mobile_219.svg": 67011,
	"./assets_mobile/img/game_main_mobile_220.svg": 65910,
	"./assets_mobile/img/game_main_mobile_221.svg": 57172,
	"./assets_mobile/img/game_main_mobile_222.svg": 4068,
	"./assets_mobile/img/game_main_mobile_223.svg": 60250,
	"./assets_mobile/img/game_main_mobile_224.svg": 86980,
	"./assets_mobile/img/game_main_mobile_225.svg": 17443,
	"./assets_mobile/img/game_main_mobile_226.svg": 53210,
	"./assets_mobile/img/game_main_mobile_227.svg": 61831,
	"./assets_mobile/img/game_main_mobile_228.svg": 33023,
	"./assets_mobile/img/game_main_mobile_301.svg": 15806,
	"./assets_mobile/img/game_main_mobile_6.svg": 38655,
	"./assets_mobile/img/game_main_mobile_9.svg": 35563,
	"./assets_mobile/img/game_main_mobile_bomb.svg": 65522,
	"./assets_mobile/img/game_main_mobile_sp.svg": 33326,
	"./assets_mobile/img/gamecard_bg.svg": 35494,
	"./assets_mobile/img/gamemainbgoff.svg": 88056,
	"./assets_mobile/img/gamemainbgon.svg": 90497,
	"./assets_mobile/img/habanero_m.svg": 78401,
	"./assets_mobile/img/headbgoff.svg": 73307,
	"./assets_mobile/img/headbgon.svg": 457,
	"./assets_mobile/img/headboard_off.svg": 52266,
	"./assets_mobile/img/headboard_on.svg": 64347,
	"./assets_mobile/img/headin_off.svg": 78931,
	"./assets_mobile/img/headin_on.svg": 54740,
	"./assets_mobile/img/headmy_off.svg": 85813,
	"./assets_mobile/img/headmy_on.svg": 51272,
	"./assets_mobile/img/headout_off.svg": 92591,
	"./assets_mobile/img/headout_on.svg": 11386,
	"./assets_mobile/img/headqna_off.svg": 97592,
	"./assets_mobile/img/headqna_on.svg": 22228,
	"./assets_mobile/img/heaerBg.svg": 80641,
	"./assets_mobile/img/hotelSlot_off.svg": 23186,
	"./assets_mobile/img/hotelSlot_on.svg": 95414,
	"./assets_mobile/img/hotel_off.svg": 50722,
	"./assets_mobile/img/hotel_on.svg": 64471,
	"./assets_mobile/img/hotelslot_game.svg": 44794,
	"./assets_mobile/img/icon_acount.svg": 42035,
	"./assets_mobile/img/icon_acountName.svg": 99682,
	"./assets_mobile/img/icon_all.svg": 50948,
	"./assets_mobile/img/icon_allMy.svg": 86985,
	"./assets_mobile/img/icon_arrow.svg": 34418,
	"./assets_mobile/img/icon_arrowBottom.svg": 14870,
	"./assets_mobile/img/icon_arrowPk.svg": 20217,
	"./assets_mobile/img/icon_arrowTop.svg": 63617,
	"./assets_mobile/img/icon_ask.svg": 67612,
	"./assets_mobile/img/icon_bank.svg": 65612,
	"./assets_mobile/img/icon_bet.svg": 10637,
	"./assets_mobile/img/icon_betIist.svg": 57313,
	"./assets_mobile/img/icon_betMy.svg": 59059,
	"./assets_mobile/img/icon_bets.svg": 13307,
	"./assets_mobile/img/icon_bg.svg": 79362,
	"./assets_mobile/img/icon_bottom_gr.svg": 20814,
	"./assets_mobile/img/icon_brdelete.svg": 43920,
	"./assets_mobile/img/icon_cash.svg": 35954,
	"./assets_mobile/img/icon_casino_off.svg": 90771,
	"./assets_mobile/img/icon_casino_on.svg": 10540,
	"./assets_mobile/img/icon_charge.svg": 30296,
	"./assets_mobile/img/icon_check.svg": 23148,
	"./assets_mobile/img/icon_cherry.svg": 3201,
	"./assets_mobile/img/icon_code.svg": 63649,
	"./assets_mobile/img/icon_coin.svg": 73539,
	"./assets_mobile/img/icon_coinm.svg": 23746,
	"./assets_mobile/img/icon_commentList.svg": 26919,
	"./assets_mobile/img/icon_copy.svg": 99955,
	"./assets_mobile/img/icon_cs.svg": 95788,
	"./assets_mobile/img/icon_customMy.svg": 29293,
	"./assets_mobile/img/icon_customer.svg": 37880,
	"./assets_mobile/img/icon_date.svg": 79570,
	"./assets_mobile/img/icon_dateList.svg": 51558,
	"./assets_mobile/img/icon_dateMe.svg": 15784,
	"./assets_mobile/img/icon_dateRead.svg": 16661,
	"./assets_mobile/img/icon_delete.svg": 67069,
	"./assets_mobile/img/icon_deposit.svg": 40817,
	"./assets_mobile/img/icon_deposit_off.svg": 75111,
	"./assets_mobile/img/icon_deposit_on.svg": 22671,
	"./assets_mobile/img/icon_dice.svg": 93394,
	"./assets_mobile/img/icon_exchange.svg": 26324,
	"./assets_mobile/img/icon_exchanges.svg": 48338,
	"./assets_mobile/img/icon_exclamat.svg": 13975,
	"./assets_mobile/img/icon_faq.svg": 37649,
	"./assets_mobile/img/icon_faqMy.svg": 98206,
	"./assets_mobile/img/icon_file.svg": 99823,
	"./assets_mobile/img/icon_filter.svg": 16460,
	"./assets_mobile/img/icon_game.svg": 49000,
	"./assets_mobile/img/icon_gameGuide.svg": 64481,
	"./assets_mobile/img/icon_gameM.svg": 83342,
	"./assets_mobile/img/icon_gameMoney.svg": 21345,
	"./assets_mobile/img/icon_give.svg": 29238,
	"./assets_mobile/img/icon_gives.svg": 44925,
	"./assets_mobile/img/icon_go.svg": 93300,
	"./assets_mobile/img/icon_guide.svg": 52700,
	"./assets_mobile/img/icon_guser.svg": 86512,
	"./assets_mobile/img/icon_home.svg": 54253,
	"./assets_mobile/img/icon_home_off.svg": 21404,
	"./assets_mobile/img/icon_home_on.svg": 26073,
	"./assets_mobile/img/icon_hotelcasino_off.svg": 22034,
	"./assets_mobile/img/icon_hotelcasino_on.svg": 755,
	"./assets_mobile/img/icon_id.svg": 32542,
	"./assets_mobile/img/icon_in.svg": 92610,
	"./assets_mobile/img/icon_inMy.svg": 86018,
	"./assets_mobile/img/icon_info.svg": 96125,
	"./assets_mobile/img/icon_inm.svg": 14785,
	"./assets_mobile/img/icon_inout.svg": 54644,
	"./assets_mobile/img/icon_list.svg": 94513,
	"./assets_mobile/img/icon_live.svg": 5320,
	"./assets_mobile/img/icon_livecasino.svg": 22241,
	"./assets_mobile/img/icon_login.svg": 7944,
	"./assets_mobile/img/icon_logout.svg": 56024,
	"./assets_mobile/img/icon_mRight.svg": 46342,
	"./assets_mobile/img/icon_mainFaq.svg": 97046,
	"./assets_mobile/img/icon_menu.svg": 73050,
	"./assets_mobile/img/icon_mfaq.svg": 47373,
	"./assets_mobile/img/icon_mgiude.svg": 17056,
	"./assets_mobile/img/icon_money.svg": 82646,
	"./assets_mobile/img/icon_moneys.svg": 92310,
	"./assets_mobile/img/icon_more.svg": 42629,
	"./assets_mobile/img/icon_moreBl.svg": 56039,
	"./assets_mobile/img/icon_moreCon.svg": 67300,
	"./assets_mobile/img/icon_moreMy.svg": 68471,
	"./assets_mobile/img/icon_morem.svg": 9873,
	"./assets_mobile/img/icon_msg.svg": 45918,
	"./assets_mobile/img/icon_msgLogo.svg": 80028,
	"./assets_mobile/img/icon_msgMy.svg": 89337,
	"./assets_mobile/img/icon_msgOff.svg": 51714,
	"./assets_mobile/img/icon_msgOn.svg": 42090,
	"./assets_mobile/img/icon_msgs.svg": 95264,
	"./assets_mobile/img/icon_myAll.svg": 65107,
	"./assets_mobile/img/icon_mycharge.svg": 77030,
	"./assets_mobile/img/icon_myexchange.svg": 19085,
	"./assets_mobile/img/icon_myfaq.svg": 57871,
	"./assets_mobile/img/icon_mygive.svg": 10557,
	"./assets_mobile/img/icon_mymsg.svg": 1922,
	"./assets_mobile/img/icon_mynotice.svg": 69524,
	"./assets_mobile/img/icon_myout.svg": 13187,
	"./assets_mobile/img/icon_mypoint.svg": 20166,
	"./assets_mobile/img/icon_myqna.svg": 42018,
	"./assets_mobile/img/icon_myset.svg": 46551,
	"./assets_mobile/img/icon_nick.svg": 88050,
	"./assets_mobile/img/icon_notice.svg": 15154,
	"./assets_mobile/img/icon_noticeMy.svg": 1615,
	"./assets_mobile/img/icon_notice_off.svg": 24062,
	"./assets_mobile/img/icon_notice_on.svg": 86744,
	"./assets_mobile/img/icon_onProfile.svg": 48958,
	"./assets_mobile/img/icon_out.svg": 19675,
	"./assets_mobile/img/icon_outMy.svg": 72374,
	"./assets_mobile/img/icon_outm.svg": 54462,
	"./assets_mobile/img/icon_password.svg": 21847,
	"./assets_mobile/img/icon_phone.svg": 98451,
	"./assets_mobile/img/icon_plus.svg": 19896,
	"./assets_mobile/img/icon_point.svg": 62022,
	"./assets_mobile/img/icon_pointC.svg": 44283,
	"./assets_mobile/img/icon_pointHave.svg": 90856,
	"./assets_mobile/img/icon_pointM.svg": 81898,
	"./assets_mobile/img/icon_pointMy.svg": 3997,
	"./assets_mobile/img/icon_points.svg": 28006,
	"./assets_mobile/img/icon_pointz.svg": 18359,
	"./assets_mobile/img/icon_pro1.svg": 72431,
	"./assets_mobile/img/icon_pro2.svg": 35764,
	"./assets_mobile/img/icon_profile.svg": 13249,
	"./assets_mobile/img/icon_promore.svg": 59053,
	"./assets_mobile/img/icon_promotion.svg": 92779,
	"./assets_mobile/img/icon_pw.svg": 85838,
	"./assets_mobile/img/icon_pwm.svg": 35311,
	"./assets_mobile/img/icon_qna.svg": 10074,
	"./assets_mobile/img/icon_qna1.svg": 31652,
	"./assets_mobile/img/icon_question.svg": 60411,
	"./assets_mobile/img/icon_questionz.svg": 28518,
	"./assets_mobile/img/icon_ranking.svg": 1930,
	"./assets_mobile/img/icon_rate_off.svg": 51443,
	"./assets_mobile/img/icon_rate_on.svg": 57864,
	"./assets_mobile/img/icon_re.svg": 31986,
	"./assets_mobile/img/icon_reply.svg": 76119,
	"./assets_mobile/img/icon_reset.svg": 4530,
	"./assets_mobile/img/icon_resets.svg": 36524,
	"./assets_mobile/img/icon_result.svg": 35401,
	"./assets_mobile/img/icon_rightarrow.svg": 5191,
	"./assets_mobile/img/icon_sbtn.svg": 4504,
	"./assets_mobile/img/icon_search.svg": 76234,
	"./assets_mobile/img/icon_searchs.svg": 81633,
	"./assets_mobile/img/icon_service_off.svg": 86259,
	"./assets_mobile/img/icon_service_on.svg": 47303,
	"./assets_mobile/img/icon_set.svg": 71061,
	"./assets_mobile/img/icon_setting.svg": 25702,
	"./assets_mobile/img/icon_slot.svg": 72878,
	"./assets_mobile/img/icon_slotGo.svg": 54170,
	"./assets_mobile/img/icon_slot_off.svg": 79630,
	"./assets_mobile/img/icon_slot_on.svg": 76724,
	"./assets_mobile/img/icon_ssearch.svg": 71291,
	"./assets_mobile/img/icon_sslot.svg": 52041,
	"./assets_mobile/img/icon_top_gn.svg": 29894,
	"./assets_mobile/img/icon_user.svg": 4399,
	"./assets_mobile/img/icon_userComm.svg": 37177,
	"./assets_mobile/img/icon_userList.svg": 52517,
	"./assets_mobile/img/icon_userMe.svg": 85624,
	"./assets_mobile/img/icon_userRead.svg": 42180,
	"./assets_mobile/img/icon_viewRead.svg": 10933,
	"./assets_mobile/img/icon_withdraw_off.svg": 83211,
	"./assets_mobile/img/icon_withdraw_on.svg": 45346,
	"./assets_mobile/img/icon_write.svg": 37760,
	"./assets_mobile/img/icon_writes.svg": 8339,
	"./assets_mobile/img/khan.svg": 76181,
	"./assets_mobile/img/level2.svg": 28888,
	"./assets_mobile/img/live_off.svg": 1895,
	"./assets_mobile/img/live_on.svg": 45443,
	"./assets_mobile/img/login_bg.svg": 25404,
	"./assets_mobile/img/login_logo.svg": 61073,
	"./assets_mobile/img/mBanner.svg": 5007,
	"./assets_mobile/img/m_main_image.svg": 62845,
	"./assets_mobile/img/mainGameBg.svg": 4837,
	"./assets_mobile/img/meberix_m.svg": 47367,
	"./assets_mobile/img/menuBgOff.svg": 18468,
	"./assets_mobile/img/menuBgOn.svg": 1337,
	"./assets_mobile/img/menu_icon.svg": 55134,
	"./assets_mobile/img/menu_user.svg": 89370,
	"./assets_mobile/img/menuoff.svg": 35211,
	"./assets_mobile/img/menuon.svg": 65204,
	"./assets_mobile/img/message_off.svg": 35676,
	"./assets_mobile/img/microgaming_m.svg": 73243,
	"./assets_mobile/img/mini_off.svg": 79578,
	"./assets_mobile/img/mini_on.svg": 70750,
	"./assets_mobile/img/mob_main_banner.svg": 88126,
	"./assets_mobile/img/moca_logo.svg": 74430,
	"./assets_mobile/img/moca_white_logo.svg": 17862,
	"./assets_mobile/img/my_bg.svg": 8287,
	"./assets_mobile/img/mycicon.svg": 75377,
	"./assets_mobile/img/mygicon.svg": 51846,
	"./assets_mobile/img/mypage_point_waring.svg": 33860,
	"./assets_mobile/img/mypicon.svg": 55649,
	"./assets_mobile/img/netent_m.svg": 64194,
	"./assets_mobile/img/news1.svg": 24450,
	"./assets_mobile/img/news2.svg": 39512,
	"./assets_mobile/img/news3.svg": 9120,
	"./assets_mobile/img/open_message.svg": 89005,
	"./assets_mobile/img/orange_logo.svg": 39594,
	"./assets_mobile/img/pang_logo.svg": 16463,
	"./assets_mobile/img/playngo_m.svg": 72853,
	"./assets_mobile/img/playson_m.svg": 61106,
	"./assets_mobile/img/pointo.svg": 91016,
	"./assets_mobile/img/pragmaticplay_m.svg": 67293,
	"./assets_mobile/img/quickspin_m.svg": 19932,
	"./assets_mobile/img/rateb.svg": 32597,
	"./assets_mobile/img/ratem.svg": 67190,
	"./assets_mobile/img/ratet.svg": 43667,
	"./assets_mobile/img/redrake_m.svg": 66261,
	"./assets_mobile/img/redtiger_m.svg": 86101,
	"./assets_mobile/img/relax_m.svg": 95211,
	"./assets_mobile/img/setting_completeo.svg": 43663,
	"./assets_mobile/img/setting_incompleteo.svg": 67506,
	"./assets_mobile/img/sfirehead_m.svg": 14968,
	"./assets_mobile/img/slot_off.svg": 83595,
	"./assets_mobile/img/slot_on.svg": 91509,
	"./assets_mobile/img/sports_off.svg": 40040,
	"./assets_mobile/img/sports_on.svg": 80710,
	"./assets_mobile/img/titan_logo.svg": 72,
	"./assets_mobile/img/titleBg.svg": 73881,
	"./assets_mobile/img/treasure_logo.svg": 10128,
	"./assets_mobile/img/usePointo.svg": 78698,
	"./assets_mobile/img/vn.svg": 28081,
	"./assets_mobile/img/whpnut_logo.svg": 73214,
	"./assets_mobile/img/winner_mobile/slot_family_jdb.svg": 4425,
	"./styles/webfonts/fa-brands-400.svg": 48826,
	"./styles/webfonts/fa-regular-400.svg": 26952,
	"./styles/webfonts/fa-solid-900.svg": 96031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87283;